import { render } from "./PetNote.vue?vue&type=template&id=586d51b3&scoped=true"
import script from "./PetNote.vue?vue&type=script&lang=js"
export * from "./PetNote.vue?vue&type=script&lang=js"

import "./PetNote.vue?vue&type=style&index=0&id=586d51b3&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586d51b3"]])

export default __exports__